import { DoqFaceSvgProps } from '../types';

const BlockDiagramError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1405_41729)">
      <g clipPath="url(#clip1_1405_41729)">
        {/* mask to hide the bottom outline of the circle */}
        <mask id="bottom-mask-block-diagram-error">
          <circle cx="160" cy="160" r="160" fill="white" />
          <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
        </mask>
        <circle
          cx="160"
          cy="160"
          r="160"
          fill="#FCBF4C"
          mask="url(#bottom-mask-block-diagram-error)"
        />

        <mask
          id="mask0_1405_41729"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="320"
          height="320"
        >
          <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
        </mask>
        <g mask="url(#mask0_1405_41729)">
          <rect x="80" y="120" width="160" height="200" fill="white" />
        </g>
        <path
          d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
          fill="#2974C4"
        />
        <path
          d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M130 161.5C127.791 161.5 126 163.291 126 165.5V186.5C126 188.709 127.791 190.5 130 190.5H151C153.209 190.5 155 188.709 155 186.5V179.5H165V186.5C165 188.709 166.791 190.5 169 190.5H190C192.209 190.5 194 188.709 194 186.5V165.5C194 163.291 192.209 161.5 190 161.5H169C166.791 161.5 165 163.291 165 165.5V176.5H155V165.5C155 163.291 153.209 161.5 151 161.5H130ZM151 164.5H130C129.448 164.5 129 164.948 129 165.5V186.5C129 187.052 129.448 187.5 130 187.5H151C151.552 187.5 152 187.052 152 186.5V165.5C152 164.948 151.552 164.5 151 164.5ZM190 164.5H169C168.448 164.5 168 164.948 168 165.5V186.5C168 187.052 168.448 187.5 169 187.5H190C190.552 187.5 191 187.052 191 186.5V165.5C191 164.948 190.552 164.5 190 164.5Z"
          fill="#2974C4"
        />
        <path
          opacity="0.5"
          d="M88 240C88 235.582 91.5817 232 96 232H224C228.418 232 232 235.582 232 240V296C232 300.418 228.418 304 224 304H96C91.5817 304 88 300.418 88 296V240Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.06 247.927C112.06 252.368 108.46 255.968 104.02 255.968C104.008 255.968 103.996 255.968 103.985 255.968V263.896H136.618C136.691 263.703 136.827 263.529 137.024 263.406L147.478 256.914C147.487 256.908 147.496 256.903 147.505 256.897V247.871H136.771C136.219 247.871 135.771 247.424 135.771 246.871V240.935C135.771 240.383 136.219 239.935 136.771 239.935H158.878C159.43 239.935 159.878 240.383 159.878 240.935V246.871C159.878 247.424 159.43 247.871 158.878 247.871H148.505V256.897C148.515 256.903 148.524 256.908 148.533 256.914L158.986 263.406C159.616 263.798 159.616 264.714 158.986 265.105L148.533 271.598C148.524 271.604 148.515 271.609 148.505 271.615V275.702H167.945V272.926C167.945 272.373 168.392 271.926 168.945 271.926H183.244C183.796 271.926 184.244 272.373 184.244 272.926V275.702H195.997V263.946H192.94C192.387 263.946 191.94 263.498 191.94 262.946V256.911C191.94 256.359 192.387 255.911 192.94 255.911H195.997V247.92H187.885C185.742 247.92 184.006 246.183 184.006 244.041C184.006 241.899 185.742 240.162 187.885 240.162H204.233C206.376 240.162 208.112 241.899 208.112 244.041C208.112 246.183 206.376 247.92 204.233 247.92H196.997V255.911H199.276C199.828 255.911 200.276 256.359 200.276 256.911V259.428H216.038C216.287 257.479 217.952 255.972 219.97 255.972C222.159 255.972 223.934 257.747 223.934 259.936C223.934 262.126 222.159 263.9 219.97 263.9C217.947 263.9 216.278 262.385 216.036 260.428H200.276V262.946C200.276 263.498 199.828 263.946 199.276 263.946H196.997V287.951H204.997C207.216 287.951 209.015 289.75 209.015 291.969C209.015 294.187 207.216 295.986 204.997 295.986H187.994C185.775 295.986 183.976 294.187 183.976 291.969C183.976 289.75 185.775 287.951 187.994 287.951H195.997V276.702H184.244V278.96C184.244 279.512 183.796 279.96 183.244 279.96H168.945C168.392 279.96 167.945 279.512 167.945 278.96V276.702H148.505V288.111C150.448 288.367 151.947 290.029 151.947 292.041C151.947 294.23 150.172 296.005 147.983 296.005C145.794 296.005 144.019 294.23 144.019 292.041C144.019 290.014 145.541 288.342 147.505 288.106V276.702H115.248C115.16 276.811 115.046 276.904 114.906 276.973L108.782 279.981V288.136C110.644 288.461 112.06 290.086 112.06 292.041C112.06 294.23 110.285 296.005 108.096 296.005C105.907 296.005 104.132 294.23 104.132 292.041C104.132 289.958 105.739 288.25 107.782 288.089V279.98L101.658 276.973C100.912 276.607 100.912 275.544 101.658 275.178L107.782 272.171V264.896H102.985V255.902C99.033 255.394 95.9795 252.017 95.9795 247.927C95.9795 243.487 99.5792 239.887 104.02 239.887C108.46 239.887 112.06 243.487 112.06 247.927ZM115.394 275.702C115.308 275.486 115.146 275.296 114.906 275.178L108.782 272.171V264.896H136.782C136.849 264.976 136.929 265.046 137.024 265.105L147.478 271.598C147.487 271.604 147.496 271.609 147.505 271.615V275.702H115.394Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M161.851 200.005C160.816 200.082 160 200.946 160 202C160 203.105 160.895 204 162 204H176.5C178.433 204 180 205.567 180 207.5C180 207.67 179.988 207.837 179.964 208.001L180 208.001C180.001 209.105 180.896 210 182 210C183.105 210 184 209.105 184 208C184 207.942 183.997 207.884 183.993 207.826L183.984 208.001C183.994 207.835 184 207.668 184 207.5C184 203.358 180.642 200 176.5 200H162L161.851 200.005Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1405_41729">
        <rect width="320" height="320" fill="white" />
      </clipPath>
      <clipPath id="clip1_1405_41729">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export { BlockDiagramError };
